<template>
    <div class="relative">
        <div @click="showCollapse=!showCollapse" class="relative">
            <span class="material-symbols-outlined text-enriqueto_green cursor-pointer" >
                notifications
            </span>
            <span v-if="$page.props.unreadNotifications.length > 0" class=" w-2 h-2 bg-red top-0 right-0 absolute rounded-full"></span>
        </div>

        <div v-if="showCollapse" class="absolute right-0 p-5 bg-white w-96 top-10 rounded-xl shadow-sm z-50">
            <p v-for="notification in $page.props.unreadNotifications"> <div class=" inline-block w-2 h-2 bg-enriqueto_green rounded-full"></div> {{notification.data.title}} - {{notification.data.content}} </p>
            <Link href="/" class="w-full m-auto text-center text-enriqueto_green block mt-5 text-3xl underline">Ver mas</Link>
        </div>
    </div>
</template>
<script setup>
import {ref} from 'vue';
import { Link } from '@inertiajs/inertia-vue3'
const showCollapse = ref(false);
</script>
<style lang="">
    
</style>